import type { CheckboxTreeState } from './types'

export const setCheckedAndAllChildren = (
  state: CheckboxTreeState,
  id: string,
  status: boolean
) => {
  const item = state.get(id)
  if (item) {
    item.checked = status
    item.indeterminate = false
    item.children?.forEach((child) => {
      setCheckedAndAllChildren(state, child, status)
    })
  }
}

export const updateParentStatus = (
  state: CheckboxTreeState,
  id: string | null
) => {
  if (!id) {
    return
  }

  const item = state.get(id)
  if (!item) {
    return
  }

  if (
    item.children?.every((childId) => {
      const child = state.get(childId)
      return child && child.checked && !child.indeterminate
    })
  ) {
    item.checked = true
    item.indeterminate = false
  } else if (
    item.children?.every((childId) => {
      const child = state.get(childId)
      return child && !child.checked && !child.indeterminate
    })
  ) {
    item.checked = false
    item.indeterminate = false
  } else {
    item.checked = true
    item.indeterminate = true
  }
  updateParentStatus(state, item.parentId)
}
